export const IServerNames = {
  DEFAULT: 0,
  MAIN: 1,
  // BUSINESS: process.env.DEV ? 5 : 5,
  BUSINESS: process.env.DEV ? 2 : 2,
  ASSET: 3,
}

export const SocketEvents = {
  UPDATED_ORDER: 'portal/updated-order',
  DYNAMIC_EVENT: 'portal/dynamic-event',
}
